import { createContext, type ReactElement, useContext } from 'react';
import useUrlPermission from '@hooks/url-permission';
import { DynamicFieldsContainer } from './DynamicComponents/styles/common';
import { Field } from './DynamicComponents/Desktop/Field';
import type { ShipmentDynamicFieldType } from '@hooks/shipment';
import type { IDropdownOption } from '@elements/Dropdown';

// @ts-expect-error - TS2554: Expected 1 arguments, but got 0.
const DynamicContext = createContext();

type DynamicFieldsV2Props = {
  data: ShipmentDynamicFieldType[];
  onChange?: (name: string, value: any, callAttributeApi?: boolean) => void;
  actionAllowed?: boolean;
  actionButtonClick: (item: ShipmentDynamicFieldType) => void;
  addNestedField: (item: ShipmentDynamicFieldType) => void;
  button?: ReactElement;
  errors: Record<string, any>;
  values?: Record<string, any>;
  documents?: any;
  readOnly?: boolean;
  removeDocument?: (doc: any) => void;
  removeNestedField: (item: string, index: number) => void;
  stepData?: ShipmentDynamicFieldType[];
  uploadDocument?: (doc: any) => void;
  dimensionsUnit?: string;
  weightUnit?: string;
  countryOptions?: IDropdownOption[];
  isFBA?: boolean;
};

export function DynamicFieldsV2(props: DynamicFieldsV2Props) {
  const { disabled, hidden } = useUrlPermission();
  const {
    data,
    errors,
    values,
    documents,
    readOnly,
    dimensionsUnit,
    actionButtonClick,
    weightUnit,
    uploadDocument,
    countryOptions,
    removeDocument,
    actionAllowed,
    isFBA,
  } = props;

  return (
    <DynamicContext.Provider
      value={{
        is2DBarcode: values?.contentInformationSource === 'BARCODE_2D',
        documents,
        readOnly,
        dimensionsUnit,
        actionButtonClick,
        weightUnit,
        uploadDocument,
        countryOptions,
        removeDocument,
        actionAllowed,
        isFBA,
      }}
    >
      <DynamicFieldsContainer>
        {data?.map((item, index) => (
          <Field
            {...props}
            key={item.name}
            value={values?.[item.name]}
            error={errors?.[item.name]}
            item={item}
            index={index}
            layoutClass={item.layoutClass}
            hidden={hidden}
            disabled={disabled}
          />
        ))}
      </DynamicFieldsContainer>
    </DynamicContext.Provider>
  );
}

export const useDynamicContext = () => useContext(DynamicContext);
